import React from 'react';

import { splitCoverColumns } from './coverData';

import './styles.scoped.css';

// PRST-134 — the bordered cover block on the results screen.
//
// Two columns per the Axure mockup (six and five since the 2026-09-23 redaction): a thin light-grey
// box with no internal dividers, no row striping and no column rule. The two columns run
// independently — the mockup's rows are not baseline-paired, because the two address fields on the
// left wrap to two lines.
//
// It renders buildCoverFields() output, which is the same ordered array page 1 of the PDF
// renders and splits the same way. The two cannot share markup (react-pdf's reconciler rejects
// DOM elements), so sharing the shaped data is what keeps them from quietly disagreeing.
const SummaryColumn = ({ fields }) => (
  <div className="summary-column">
    {fields.map(({ label, value }) => (
      <div className="summary-row" key={label}>
        <span className="summary-label">{label}</span>
        <span className="summary-value">{value}</span>
      </div>
    ))}
  </div>
);

const WorkerSummary = ({ fields = [] }) => {
  const { left, right } = splitCoverColumns(fields);
  return (
    <div className="summary-box">
      <SummaryColumn fields={left} />
      <SummaryColumn fields={right} />
    </div>
  );
};

export default WorkerSummary;
